import { AssetTypeService } from '../model/asset-type.service';
import { CrudDataSource, HateoasMultipleResponseObject, PageSpecification } from '@scisys-uim/uim-common';
import { AssetType } from 'assets-model';
import { Observable } from 'rxjs';


export class AssetTypeDataSource extends CrudDataSource<AssetType> {

  constructor(private service: AssetTypeService) {
    super();
  }

  protected callLoaderService(serviceArguments: any, pageSpec: PageSpecification): Observable<HateoasMultipleResponseObject<AssetType>> {
    return this.service.findByFullFilters(serviceArguments, pageSpec);
  }

}


